import { FC } from 'react';
import { FormControl, TextField, TextFieldProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';

export type NumberInputProps = TextFieldProps & {
  name: string;
};

export const NumberInput: FC<NumberInputProps> = (props) => {
  const [field, meta] = useField(props.name);
  const { isSubmitting } = useFormikContext();
  return (
    <FormControl>
      <TextField
        type="number"
        InputLabelProps={{ shrink: true }}
        fullWidth
        variant="outlined"
        margin={'normal'}
        {...props}
        autoComplete={props.autoComplete}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        disabled={isSubmitting || props.disabled}
        error={meta.touched && !!meta.error}
        helperText={meta.touched && meta.error}
      />
    </FormControl>
  );
};
